import type { PaginationProps } from 'modules/types'
import type { CarInterestHistory } from 'modules/carinterest/car-interest.dto'
import CONSTANT from 'modules/constant'
import { API, download, headers } from './api'

export const carInterestApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getCarInterestList: builder.mutation<PaginationProps<CarInterestHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_CAR_INTEREST_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    downloadCarInterestList: builder.mutation<PaginationProps<CarInterestHistory>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_CAR_INTEREST_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData,
        responseHandler: download,
        formData: true
      })
    })
  })
})

export const { useGetCarInterestListMutation, useDownloadCarInterestListMutation } = carInterestApi